import { Schema } from '@public/store/schemas/Schema';

interface ISportOrganizationSchema {
  name: string;
  url: string;
  sport: string;
  logo: string | null;
  mascot?: string | null;
  location: {
    address?: string | null;
    city?: string;
    state?: string;
    zipCode?: number | null;
    country?: string;
  };
}

export class SportOrganizationSchema extends Schema {
  name;
  url;
  sport;
  logo;
  mascot;
  location;

  constructor({
    name,
    url,
    sport,
    logo,
    mascot,
    location,
  }: ISportOrganizationSchema) {
    super();
    this.name = name;
    this.url = url;
    this.sport = sport;
    this.logo = logo;
    this.mascot = mascot;
    this.location = location;
  }

  toJSON() {
    return Schema.cleanse({
      '@context': 'http://schema.org',
      '@type': 'SportsOrganization',
      name: this.name,
      url: this.url,
      sport: this.sport,
      logo: this.logo,
      mascot: this.mascot,
      memberOf: {
        '@type': 'EducationalOrganization',
        name: this.name,
        url: this.url,
      },
      member: {
        '@type': 'SportsTeam',
        name: this.name,
        url: `${this.url}?sport=${this.sport}`,
      },
      location: {
        '@type': 'Place',
        name: this.name,
        address: {
          '@type': 'PostalAddress',
          streetAddress: this.location.address,
          addressLocality: this.location.city,
          addressRegion: this.location.state,
          postalCode: this.location.zipCode,
          addressCountry: this.location.country,
        },
      },
    });
  }
}
